import { UseQueryOptions } from '@tanstack/react-query';

import useQuery from 'hooks/useQuery';
import { CuredApiPaths } from 'models/enums';

import QueryKeys from './keys';

import type { TemplateSavedRowLinkDto } from 'utils/savedEmailRows';

export type SavedRowTemplateLinksResponse = { links: TemplateSavedRowLinkDto[] };

type Params = {
    templateId: number | null;
    reactQueryOptions?: UseQueryOptions<SavedRowTemplateLinksResponse, Error>;
};

/** GET /saved-rows/template-links/:templateId — maps Bee canvas row `uuid` to library row metadata. */
const useSavedRowTemplateLinks = ({ templateId, reactQueryOptions }: Params) =>
    useQuery<SavedRowTemplateLinksResponse>(
        templateId != null ? QueryKeys.SAVED_ROWS_TEMPLATE_LINKS(templateId) : ['saved-rows', 'template-links', 'none'],
        `${CuredApiPaths.SAVED_ROWS}/template-links/${templateId ?? 0}`,
        {
            enabled: templateId != null,
            ...reactQueryOptions,
        }
    );

export default useSavedRowTemplateLinks;
